/**
 * Browser storage that never throws (private windows, blocked storage, embedded
 * previews). Registration drafts use sessionStorage so personal details are
 * cleared when the tab closes.
 */
function safe(kind: 'local' | 'session') {
  const store = () => {
    try {
      return kind === 'local' ? window.localStorage : window.sessionStorage
    } catch {
      return null
    }
  }
  return {
    get<T>(key: string): T | null {
      try {
        const raw = store()?.getItem(key)
        return raw ? (JSON.parse(raw) as T) : null
      } catch {
        return null
      }
    },
    set(key: string, value: unknown) {
      try {
        store()?.setItem(key, JSON.stringify(value))
      } catch {
        /* storage full or unavailable: the page still works without it */
      }
    },
    remove(key: string) {
      try {
        store()?.removeItem(key)
      } catch {
        /* ignore */
      }
    },
  }
}

export const storage = safe('local')
export const session = safe('session')
